{
    "message": {
        "name": "Όνομα",
        "hour": "Hour",
        "day": "Ημέρα",
        "month": "Μήνας",
        "year": "Χρόνος",
        "show": "Οθόνη",
        "liters": "Λίτρα",
        "price_estimate": "Εκτιμώμενη αξία",
        "edit": "Επεξεργασία",
        "move_up": "Μετακίνηση πάνω",
        "move_down": "Μετακίνηση κάτω",
        "edit_order": "Επεξεργασία σειράς",
        "finish_ordering": "Ολοκλήρωση ταξινόμησης",
        "notes": "Σημειώσεις (προσεχώς)",
        "alarms": "Συναγερμός",
        "sharing": "Kαταμερισμός",
        "remove": "Αφαίρεση",
        "confirm_remove_object": "Είσαι σίγουρος ότι θέλεις να αφαιρεθεί αυτό το αντικείμενο;",
        "confirm_remove_homebase": "Είσαι σίγουρος ότι θέλεις να αφαιρεθεί αυτή η homebase;",
        "confirm_remove_prefix": "Είσαι σίγουρος, θέλεις να αφαιρεθεί ",
        "postfix_building": "κτίριο",
        "postfix_unit": "διαμέρισμα/γραφείο",
        "postfix_transmitter": "μεταδότης ",
        "postfix_validation_transmitter": "Επίβεβαιώση Μεταδότη ",
        "confirm_remove_transmitter": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον μεταδότη;",
        "confirm_remove_transmitter_billing": "Η αφαίρεση μπορεί να αλλοιώσει δεδομένα για την κατανομή.",
        "confirm_remove_transmitter_unused": "Μην αφαιρείτε ποτέ μη χρησιμοποιούμενους αλλά προηγουμένως ενεργούς μεταδότες.",
        "confirm_remove_transmitter_mistake": "Αφαίρεση, ο μεταδότης προστέθηκε κατά λάθος",
        "cold_water": "Κρύο νερό",
        "hot_water": "Ζεστό νερό",
        "cold_and_hot_water": "Cold and hot water",
        "total_water": "Σύνολο",
        "add_building": "Πρόσθεση κτιρίου",
        "edit_building": "Επεξεργασία κτιρίου",
        "cancel": "Ακύρωση",
        "loading": "Φόρτωση…",
        "no_records": "Δεν υπάρχουν εγγραφές",
        "create": "Δημιουργία",
        "street": "Οδός",
        "house_number": "Αριθμός οικίας",
        "city": "Πόλη",
        "zip": "Τ.Κ.",
        "country": "Χώρα",
        "price_estimate_cold_water": "Τιμή ανά 1 λίτρο κρύου νερού",
        "price_estimate_hot_water": "Τιμή ανά 1 λίτρο ζεστού νερού",
        "price_estimate_power": "Price of 1 kWh",
        "price_estimate_heat": "Τιμή ανά μονάδα",
        "price_estimate_water": "Τιμή ανά 1 λίτρο νερού",
        "from_parent_object": "Γονικό Αντικείμενο ",
        "price_unit": "Ευρώ ανα λίτρο",
        "save": "Αποθήκευση",
        "add_homebase": "Προσθήκη βάσης",
        "building": "Κτίριο",
        "serial_number": "Σειριακός αριθμός",
        "add_transmitter": "Προσθήκη Μεταδότη ",
        "edit_transmitter": "Επεξεργασία Μεταδότη ",
        "transmitter": "Μεταδότης ",
        "transmitters": "Μεταδότης",
        "transmitter_name_placeholder": "Όνομα χώρου μεταδότη / πομπού πχ. μπάνιο",
        "unit": "Διαμέρισμα/Γραφείο",
        "water_meter": "Υδρόμετρο",
        "not_used": "Δεν είναι σε χρήση",
        "correction": "Initial water meter reading (Διορθώσεις)",
        "correction_water": "Initial water meter reading (Διορθώσεις) l",
        "correction_power": "Initial electricity meter reading (Διορθώσεις) kWh",
        "correction_gas": "Initial gas meter reading (correction) l",
        "correction_heat": "Initial heat meter reading (correction)",
        "koeficient_polohy": "Position coefficient",
        "koeficient_svetove_strany": "World side coefficient",
        "type": "Τύπος",
        "add_validation_transmitter": "Προσθήκη Επίβεβαιώσης Μεταδότη",
        "validation_transmitter_explanation": "Επίκυρωση μεταδότη ειναι ένας μεταδότης συνδεδεμενος στην επικυρωση του υδρομέτρου. <a href='https://chytrevodomery.cz/jak-to-funguje/kontrolni-vodomery' target='_blank'>Περισσότερες Πληροφορίες</a>",
        "whole_building": "Ολόκληρο κτίριο",
        "whole_organization": "Ολόκληρος οργανισμός",
        "add_unit": "Προσθήκη διαμερισματος/γραφείου",
        "edit_unit": "Προσθήκη διαμερισματος/γραφείου",
        "unit_name_placeholder": "αριθμ. διαμερίσματος",
        "floor": "Όροφος",
        "edit_organization": "Επεξεργασία οργανισμού",
        "company_id": "Εταιρική ταυτότητα",
        "dashboard": "Ταμπλό",
        "split_bill": "Εξόφληση / πληρωμή / εκχώρηση",
        "logout": "Αποσύνδεση",
        "active_devices_services": "Ενεργές συσκευές και υπηρεσίες",
        "prepaid_transmitters": "Προπληρώμενοι μεταδότες",
        "increase_limit": "Αύξηση ορίου",
        "active_transmitters": "Ενεργοί μεταδότες / πομποί",
        "out_of_which_validation": "εκ των οποίων επικυρωμένοι μεταδότες",
        "dashboard_transmitters": "Λίστα μεταδοτών",
        "dashboard_watermeters": "Επισκόπηση μετρητών νερού",
        "dashboard_electricitymeters": "Επισκόπηση μετρητών ηλεκτρικού ρεύματος",
        "dashboard_gasmeters": "Επισκόπηση μετρητών αερίου",
        "dashboard_heatmeters": "Επισκόπηση μετρητών θερμότητας",
        "active_homebases": "Ενεργές βάσεις",
        "dashboard_homebases": "Λίστα βάσεων",
        "homebases": "βάσεων",
        "increase_transmitter_limit": "Αυξηση ορίου μεταδοτών",
        "increase_transmitter_limit_explanation": "<p>Για την αύξηση του ορίου των μεταδοτών / πομπών παρακαλώ όπως επικοινωνήσετε μαζί μας στο <a href='michal.hudecek@bonega.cz'>michal.hudecek@bonega.cz</a>.</p>",
        "count": "Μέτρηση",
        "last_data": "Τελευταία ημερομηνία",
        "first_data": "Πρώτη ημερομηνία",
        "active": "Ενεγό",
        "inactive": "Inactive",
        "coming_soon": "Προσεχώς",
        "login": "Σύνδεση",
        "signup": "Εγγραφή",
        "email": "Email",
        "password": "Κωδικός Πρόσβασης",
        "show_password": "Εμφάνιση κωδικού πρόσβασης",
        "remember": "Θύμισε μου΄;",
        "first_time": "Πρώτη φορά εδώ;",
        "signup_link": "Άμεση εγγραφή",
        "signup_heading": "Δημιουργήστε ένα νέο λογαριασμό",
        "password_repeat": "Επανάληψη κωδικού πρόσβασης",
        "close": "Κλείσιμο",
        "name_required": "Το όνομα είναι υποχρεωτικό",
        "welcome_in_app": "Καλωσορίσατε στην εφαρμογή διαχείρισης νερού",
        "welcome_in_app_paragraph": "Ξεκινάτε  με την δημιουργία ενός νέου οργανισμού. Όλες οι πληροφορίες μπορούν να τροποποιηθούν αργότερα.",
        "organization_name": "Επωνυμία οργανισμού",
        "logged_out": "Επιτυχής απόσυνδεση",
        "log_in_different_account": "Σύνδεση σε διαφορετικό λογαριασμό",
        "ok": "ΟΚ",
        "invite": "Πρόσκληση",
        "registered": "Εγγεγραμμένος",
        "unregistered": "Μη εγγεγραμμένος",
        "resend_invitation": "Νέα πρόσκληση",
        "dashboard_share": "Κοινή χρήση",
        "timezone": "Ζώνη ώρας",
        "sharing_people": "Ακολουθώντας άτομα που θα έχουν προσβαση στην φόρμα των δεδομένων <b>{object}</b>:",
        "sharing_explanation": "Δίνω πρόσβαση στου πίνακες καταναλώσεων για <b>{object}</b> σε άλλα άτομα. Αυτοί δεν θα μπορούν να αλλάξουν τιμές ή άλλες ρυθμίσεις.",
        "email_invite_placeholder": "Εισαγωγή ηλεκτρονικής διεύθυνσης",
        "personal_data_processing": "Πληροφορίες στα επεξεργαζόμενα προσωπικά δεδομένα",
        "personal_data_link": "http://www.bonega.cz/firma/GDPR_BONEGA_zakaznici.pdf",
        "yes": "Ναι",
        "no": "Όχι",
        "field_is_required": "Αυτό το πεδίο είναι απαραίτητο",
        "invalid_format": "Λανθασμένη μορφή",
        "number_too_small": "Η τιμή πρέπει να είναι > {0}",
        "number_too_big": "Η τιμή πρέπει να είναι < {0}",
        "invalid_number": "Λανθασμένος αριθμός",
        "invalid_integer": "Η τιμή δεν είναι ακαίρεος",
        "text_too_small": "Το κείμενο πρέπει να είναι > {1} μήκος χαρακτήρων (τρέχων {0})",
        "text_too_big": "Το κείμενο πρέπει να είναι < {1} μήκος χαρακτήρων (τρέχων {0})",
        "this_not_text": "Αυτό δεν είναι ένα κείμενο",
        "this_not_array": "Αυτό δεν είναι ένας πίνακας ",
        "select_min_items": "Ελάχιστη επιλογή {0} αντικειμένων",
        "select_max_items": "Μέγιστη επιλογή {0} αντικειμένων",
        "invalid_date": "Άκυρη ημερομηνία",
        "date_is_early": "Η ημερομηνία πρέπει να είναι > {1} (τρέχων {0})",
        "date_is_late": "Η ημερομηνία πρέπει να είναι > {1} (τρέχων {0})",
        "invalid_email": "Άκυρη ηλεκτρονική διεύθυνση.",
        "invalid_uRL": "Άκυρη διεύθυνση",
        "invalid_card": "Άκυρη μορφή κάρτας",
        "invalid_card_number": "Άκυρος αριθμός κάρτας",
        "invalid_text_contain_number": "Το κείμενο δεν μπορεί να περιέχει αριθμούς ή ειδικούς χαρακτήρες",
        "invalid_text_contain_spec": "Το κείμενο δεν μπορεί να ειδικούς χαρακτήρες",
        "transmitter_not_used": "Τουλάχιστον ένα πομπός θα πρέπει να χρησιμοποιείται.",
        "liters_per_hour": "Liters/hour",
        "liters_per_second": "liters/second",
        "suspicious_consumption_fluctuation": "Suspicious consumption fluctuation",
        "suspicious_consumption_fluctuation_desc": "Evaluated on the hour by comparison with historical data. Unit reverse flow (−1 to −2 L) is ignored by default.",
        "alert_on_negative_consumption": "Also warn on negative consumption",
        "consumption_last_hour": "Consumption for the last hour",
        "consumption_last_hour_desc": "Evaluated on the hour",
        "add_alarm": "Add alarm",
        "current_flow": "Current flow",
        "current_flow_desc": "Evaluated with each data transmission (5/20 minutes). Eg. broken plumbing.",
        "water_consumption_time_interval": "Sum of consumption in a given time interval",
        "water_consumption_time_interval_desc": "Eg. detecting leaking plumbing during the night",
        "alarm_data_source": "Data source",
        "alarm_source_auto": "Automatic: control meter, otherwise structure sum",
        "alarm_source_control": "Control meter",
        "alarm_source_structure": "Sum of child structure",
        "continuous_water_flow": "Continuous water flow",
        "continuous_water_flow_desc": "Eg. full bathtub (recommended onluy with 5 minute transmission intervals)",
        "between": "between",
        "and": "and",
        "alarms_active": "Alarms are active. No suspicious events have been detected yet.",
        "alarms_inactive": "No alarms set yet. Add an alarm to any building or apartment by clicking this button",
        "battery_status": "Battery status",
        "archive": "Archive",
        "archived": "Archived",
        "archive_all": "Αρχειοθέτηση όλων",
        "water_blue": "Blue wire",
        "water_red": "Red wire",
        "all_alarms": "Προβολή όλων των ειδοποιήσεων",
        "dashboard_alarms": "List of all alarms",
        "previous": "Προηγούμενο",
        "next": "Επόμενο",
        "page_of": "Σελίδα {page} / {pages} ({total})",
        "watermeter_label_red": "Číslo vodoměru (Red wire)",
        "watermeter_label_blue": "Číslo vodoměru (Blue wire)",
        "advanced_settings": "Advanced settings",
        "organization": "Organization",
        "download": "Download",
        "count_physical": "Μέτρηση",
        "count_total": "Total consumption",
        "count_reverse": "Back flow",
        "watermeter_label": "Water meter ID",
        "powermeter_label": "Electricity meter ID",
        "heatmeter_label": "Τύπος μετρητή",
        "split_bill_heading": "Split bill",
        "split_bill_verb": "Split bill",
        "split_bill_for": "for",
        "split_bill_from": "from",
        "split_bill_to": "to",
        "split_bill_in": "in",
        "split_amount": "Amount",
        "start_count": "Start count",
        "end_count": "End count",
        "consumption": "Consumption",
        "currency": "Currency",
        "all_buildings": "All buildings",
        "forgot_password": "Forgot password",
        "reset_password": "Reset password",
        "new_password": "New password",
        "new_password_again": "New password again",
        "set_new_password": "Set new password",
        "password_too_short": "Password is too short (< 8 characters)",
        "passwords_not_match": "Passwords do not match",
        "seal_number": "Seal number",
        "help": "Help",
        "help_link": "https://wateradmin.com/how-it-works/web-app",
        "water": "Water",
        "electricity": "Electricity",
        "gas": "Gas",
        "heat": "Heat",
        "valves": "Valves",
        "water_valves": "Water valves",
        "valve": "Valve",
        "add_valve": "Add valve",
        "dashboard_valves": "List of valves",
        "homebase": "Homebase",
        "dashboard_valves_explanation": "Valves are added here automatically as soon as they are paired with a homebase that is already added to the app. <a href='https://wateradmin.com/how-it-works/smart-water-valve' target='blank'>More information on smart water valves</a>.",
        "serial_number_valve": "Serial number of valve",
        "status": "Status",
        "limit_current_flow": "Limit for current flow",
        "limit_continuous_consumption": "Limit for continuous consumption",
        "limit_dripping": "Limit for dripping",
        "limit_consumption_in_time": "Limit for consumption in a time interval",
        "valve_closed": "Closed",
        "valve_closed_neutral": "Closed",
        "valve_closing": "Closing",
        "valve_open": "Open",
        "valve_open_neutral": "Open",
        "valve_opening": "Opening",
        "valve_half_open": "Half-open",
        "valve_half_open_neutral": "Half-open",
        "valve_disconnected": "Disconnected",
        "valve_state_unknown": "Unknown state",
        "last_known_state": "Last known state",
        "valve_status_may_be_stale": "The current valve status could not be loaded. The displayed status may be a few minutes old.",
        "valve_setting_resending": "Sending setting “{setting}” ({value}) for valve {valve} via homebase {homebase}.",
        "valve_setting_resending_generic": "Sending settings for valve {valve} via homebase {homebase}.",
        "valve_setting_applied": "Settings for valve {valve} were saved successfully.",
        "no_signal": "No signal",
        "hours": "hours",
        "minutes": "min",
        "close_valve": "Close valve",
        "open_valve": "Open valve",
        "liters_in": "liters in",
        "liters_after_number": "liters",
        "dripping_unit": "consecuitive hours with any consumption",
        "close_water_automatically": "Close water automatically even without internet connection",
        "when_the_current_flow": "When the current flow exceeds",
        "when_continuous_consumption_exceeds": "When continuous consumption exceeds",
        "after": "If in ",
        "consecutive_hours_with_any_consumption": "hours there is not a single hour with no consumption",
        "when_the_total_consumption": "When total consumption exceeds",
        "settings": "Settings",
        "example": "Example",
        "current_flow_example": "Cracked pipe",
        "continuous_consumption_example": "Bathtub overflow",
        "dripping_example": "Leaking toilet",
        "total_consumption_example": "Limiting daily consumption from a well",
        "check_maximum": "Check maximum",
        "maximum_until_now": "Maximum until now",
        "less_then": "less then",
        "greater_then": "greater then",
        "equals": "=",
        "billing_period": "Billing period",
        "billing_total_consumption_apartments": "Total consumption measured in apartments",
        "billing_total_consumption_control_meter": "Total consumption measured by control meter",
        "billing_consumption_difference": "Difference in measurements",
        "billing_price_per": "Price for water",
        "billing_leftover": "Unbilled amount",
        "tenants": "Number of persons",
        "persons": "Persons",
        "total_consumption_per_person": "Total Consumption per Person",
        "daily_consumption_per_person": "Daily Consumption per Person",
        "and_for_heating_water": "and for heating water",
        "cost_of_consumption": "Cost of consumption",
        "cost_of_heating_water": "Cost of heating water",
        "total_cost": "Total cost",
        "from": "From",
        "to": "To",
        "download_transmitter_data": "Download transmitter data",
        "liter": "liter",
        "currentDateTime": "Current time",
        "difference_from_validation_transmitter": "Difference from validation transmitter",
        "validation_transmitter_not_available": "Validation transmitter not available",
        "include_validation_meter_data": "Include validation meter data",
        "watts": "watts",
        "power": "kWh",
        "lowest_consumption_in_a_given_row": "lowest consumption in a given row",
        "highest_consumption_in_a_given_row": "highest consumption in a given row",
        "reset": "Reset",
        "water_meters": "Water meters",
        "electricity_meters": "Electricity meters",
        "electricity_meter": "Electricity meter",
        "gas_meters": "Μετρητές αερίου",
        "gas_meter": "Μετρητής αερίου",
        "heat_meters": "Μετρητές θερμότητας",
        "heat_meter": "Μετρητής θερμότητας",
        "measurement": "Measurement",
        "water_type": "Type of water",
        "pulse_count": "1 pulse equals",
        "pulse_count_kwh": "1 kWh equal",
        "pulse_count_l": "1 pulse equal",
        "pulses": "pulses",
        "transmitter_id": "Transmitter",
        "signal": "Signal",
        "valve_email_warning": "Notification of valve closure with link for quick opening",
        "internet_required": "requires internet connection",
        "valve_email_warning_2": "For security reasons, valve closure notifications cannot be deactivated",
        "add": "Add",
        "transmitter_battery_alarm": "Low-battery notifications for transmitters below are automatically sent to",
        "m3": "m3",
        "heat_unit": "μονάδα | μονάδες",
        "heat_units": "μονάδες",
        "new_building": "Θα δημιουργηθεί νέο κτίριο",
        "new_unit": "Θα δημιουργηθεί νέο διαμέρισμα/γραφείο",
        "data_loaded": "Ενημερώθηκε",
        "reload": "Reload"
    }
}
